import React from 'react';
import DayPicker from 'react-day-picker';

import 'react-day-picker/lib/style.css';

export default class BasicConcepts extends React.Component {
  render() {
    return (
      <div>
        <DayPicker />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/code-samples/basic-concepts-01.js